import {
  Component,
  ContentChildren,
  ElementRef,
  Input,
  QueryList,
  ViewChild,
} from '@angular/core';
import { FieldSuffixItemDirective } from './suffix-item/suffix-item.component';

@Component({
  selector: 'app-field',
  templateUrl: 'field.component.html',
  styleUrls: ['field.component.scss'],
  host: {
    '[class.state-focused]': 'focused',
    '[class.state-dirty]': 'dirty',
    '[class.state-disabled]': 'disabled',
    '[class.state-error]': 'error',
    '[class.show-error-enabled]': 'showErrorEnabled',
    '[class.field-has-label]':
      '!!labelContainerElRef?.nativeElement?.children?.length',
  },
})
export class FieldComponent {
  @ContentChildren(FieldSuffixItemDirective, { descendants: true })
  _suffixChildren: QueryList<FieldSuffixItemDirective>;

  @ViewChild('labelContainerEl', { static: true })
  labelContainerElRef: ElementRef<HTMLDivElement>;

  @Input()
  focused: boolean = false;
  @Input()
  dirty: boolean = false;
  @Input()
  disabled: boolean = false;
  @Input()
  error: boolean = false;
  @Input()
  showErrorEnabled: boolean = true;

  @Input()
  required: boolean = false;
}
